import { render, staticRenderFns } from "./LotteryUsageAdvanced.vue?vue&type=template&id=2531a146"
import script from "./LotteryUsageAdvanced.vue?vue&type=script&lang=js"
export * from "./LotteryUsageAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports